module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Toilet-6aae45dc8fd38b6472b8c4021513ea39.svg";